module.exports = __webpack_public_path__ + "static/media/hospital.96f23c0a.svg";